/**
 * THE GAME'S OWN SITE, by preview address, printed under the play page's
 * title with the game's description (owner, 2026-09-28: "just below the
 * title of the coworld, there is always first a short URL with a top right
 * arrow, and then description ... delete all the descriptions and URLs from
 * all Coworlds other than Generals.io"). Curated here until the corpus
 * carries an owner site field; a coworld missing from it shows neither.
 */
export const coworldSite: Record<string, string> = {
  "generals-competition": "https://generals.io",
  generals: "https://generals.io",
};
